import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { CACHE_NAME } from '../../common/constants';
import { getContext } from '../../common/utils/utils';
import { RecommendationsRequestMaker } from './recommendations-request-maker';
import { RecommendationsRequestBroker } from './recommendations-result/response-broker';
import { Requester } from './requester';
var useRecommendations = function useRecommendations(_ref) {
  var _ref$endpoint = _ref.endpoint,
    endpoint = _ref$endpoint === void 0 ? '/gateway/api/graphql' : _ref$endpoint,
    contextResolver = _ref.contextResolver;
  /**
   * Fetch recommendations for a given context
   */
  var getRecommendations = React.useCallback(function (args) {
    var deprecatedRerank = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    // Deconstruct the args object with deprecated arguments to make it backwards compatible
    var _ref2 = typeof args === 'number' ? {
        first: args,
        rerank: deprecatedRerank
      } : args,
      first = _ref2.first,
      rerank = _ref2.rerank,
      _ref2$config = _ref2.config,
      _ref2$config2 = _ref2$config === void 0 ? {
        cacheConfig: undefined
      } : _ref2$config,
      cacheConfig = _ref2$config2.cacheConfig;
    var recommendationRequestMaker = new RecommendationsRequestMaker(endpoint);
    var requester = new Requester(new RecommendationsRequestBroker());
    var context = getContext(contextResolver);
    return requester.fetch(recommendationRequestMaker.makeRequest({
      contextResolver: contextResolver,
      first: first,
      rerank: rerank
    }), {
      cacheConfig: cacheConfig ? _objectSpread(_objectSpread({}, cacheConfig), {}, {
        cacheName: CACHE_NAME,
        useCase: context.useCase
      }) : undefined
    });
  }, [contextResolver, endpoint]);
  return {
    getRecommendations: getRecommendations
  };
};
export default useRecommendations;